// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1qetj","requiredAsterisk":"Info_requiredAsterisk__1zaSW"};